export enum RequestHost {
    MAINDOMAIN = "MAINDOMAIN",
    CUSTOMDOMAIN = "CUSTOMDOMAIN",
    SUBDOMAIN = "SUBDOMAIN"
}

// Tracks whether we are on a custom domain / subdomain / original domain
export const XRequestHostHeader = 'x-authory-request-host';
